import { Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CompilationModel, EPackingStatus } from '../../../@models/erp/compilation';
import { ApiService } from '../../../@core/service/api.service';
import { PackingStatusData, TransportStatusData } from '../../../@models/erp/compilationData';
import { TreeService } from '../../../@core/service/tree.service';
import { isEmpty } from '../../../@core/common/global';

@Component({
  selector: 'ngx-dn-status',
  templateUrl: './dn-status.component.html',
  styleUrls: ['./dn-status.component.scss']
})
export class DnStatusComponent implements DoCheck {

  @Input() compilation: CompilationModel;
  // @Input() packingStatus: EPackingStatus;

  // public static incomingShipmentEnRoute: { [code: string]: boolean } = {};

  // public static clearShipmentStatus() {
  //   DnStatusComponent.incomingShipmentEnRoute = {};
  // }

  // that = DnStatusComponent;

  protected enRoute = null;

  public dnStatusColor: string;
  public dnStatusText: string;

  constructor (private api: ApiService, private tree: TreeService) {}

  private previousPackingStatus;
  async ngDoCheck(): Promise<void> {

    if (this.previousPackingStatus !== this.compilation.packingStatus) {
 
      // console.log('DnStatusComponent', this.previousPackingStatus, this.compilation.packingStatus, this.compilation.completelyInvoiced);
      this.previousPackingStatus = this.compilation.packingStatus;
      
      this.dnStatusColor = PackingStatusData.color(this.compilation.packingStatus);
      this.dnStatusText = PackingStatusData.text(this.compilation.packingStatus);
  
      // if (DnStatusComponent.incomingShipmentEnRoute[this.compilation.code] === undefined && this.compilation?.packingStatus === EPackingStatus.readyForPacking) {
        
      //   const spos = this.compilation.lineItems.flatMap(m => m.pfspo.flatMap(spo => spo.code));
  
      //   DnStatusComponent.incomingShipmentEnRoute[this.compilation.code] = false;
      //   for (const spo of spos) {
      //     if ((await this.api.loadCompilationByCode(spo))?.transportRun?.transportStatus == TransportStatusData.get('enRoute').id) {
      //       // this.incomingShipmentEnRoute = true;
      //       DnStatusComponent.incomingShipmentEnRoute[this.compilation.code] = true;
      //     }
      //   }
      //   // console.log('dn-status init', this.compilation.code, spos, this.incomingShipmentEnRoute);
      // }

      if (this.enRoute === null) {
        const spos = this.compilation.lineItems.flatMap(m => m.pfspo.flatMap(spo => spo.code));
  
        this.enRoute = false;
        for (const spo of spos) {
          if ((await this.api.loadCompilationByCode(spo))?.transportRun?.transportStatus == TransportStatusData.get('enRoute').id) {
            this.enRoute = true;
          }
        }
      }
  
    }
  
  }

}
